import React from 'react';
import styles from '../../../search.scss';

const ButtonFilter = (props) => {
    const { options, selected, onClick, 'data-testid': dataTestId } = props;

    const createButton = ({ option, colLength }) => {
        const { label, value } = option;
        return (
            <div className={`col-${colLength || 12 / options.length}`} key={value}>
                <button
                    type="button"
                    className={`btn btn-sm btn-block btn-default btn-search ${selected === value || (!selected && !value) ? `${styles.searchFilterBtnActive}` : ''}`}
                    onClick={() => onClick(value)}
                    data-testid={dataTestId && `${dataTestId}.btn-${value}`}
                >
                    {label}
                </button>
            </div>
        );
    };

    return (
        <div className={`row ${styles.searchFilterBtns} jcsb`} data-testid={dataTestId}>
            {options.map(option => createButton({ option, colLength: option.colLength }))}
        </div>
    );
};

export default ButtonFilter;
